$(document).ready(function(){
     $(".fancybox").fancybox({
        openEffect: "none",
        closeEffect: "none",
      });
          
        $(window).scroll(function() 
        {
         if ($(this).scrollTop() > 0)
         {
          $('.site-header').addClass("sticky_header");
         }
         else
         {
          $('.site-header').removeClass("sticky_header");
         }
        });
  
  // function activeCheck(){
  //     $(".drop-down .selected button").removeClass('active');
  //     $(".drop-down .options .nav-link").each(function (index, value) { 
  //        if($(value).hasClass('active')){
  //         $(value).parents('.options').prev().children().addClass('active');
  //       }
  //    });
  // }
  // activeCheck();
    //TOGGLING NESTED ul
  $(".drop-down .selected button").click(function() {
      $(this).parent().next().children().toggle();
      $('.drop-down .selected button').not(this).parent().next().children().hide();
  });

  
  //SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
  $(".drop-down .options ul li button").click(function() {
      // var text = $(this).html();
      // $(this).parents('.options').prev().children().html(text);
      $(".drop-down .options ul").hide();
      // activeCheck();
  }); 


  //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
  $(document).bind('click', function(e) {
      var $clicked = $(e.target);
      if (! $clicked.parents().hasClass("drop-down")){
          $(".drop-down .options ul").hide();
      }
  });  

$('.nav-link').click(function(){
        $('.nav-link').removeClass('active');
        $(this).addClass('active');
        var tagid = $(this).data('tag');
        $('.tab-item').removeClass('active').addClass('hide');
        $('#'+tagid).addClass('active').removeClass('hide');
    });
      
  		$(".accordion-btn").click(function () {
            $(".accordion-btn")
                .not(this)
                .siblings(".accordion-content")
                .slideUp();
            $(this).toggleClass("active");
            $(".accordion-btn").not(this).removeClass("active");
            $(this).siblings(".accordion-content").slideToggle();
		});
    $(document).ready(function(){
     var hash = window.location.hash;
     if (hash) {
       var element = $(hash);
       if (element.length) {
            $(hash).find(".accordion-content").show();
     }
     }
    });
});